import { z } from "zod";

export const mortgagesServicingRouterSchema = z.object({
  tenant: z.string().default("ig"),
  referenceNumber: z.string().default("0"),
});
